<template>
  <dd-header-card
      class="automation-card"
      @click="$emit('click')"
      :active="isActive"
      :header="globalAutomation.title"
  >
    <template #icon>
      <dd-icon icon="mdi mdi-web" class="color-primary" size="lg"/>
    </template>
    <template #action>
      <div @click="onConfigure" class="flex-row gap-sm">
        <dd-button
            type="primary"
            :small="true"
            class="flex-row align-items-center gap-xxs font-size-sm"
        >
          <CogOutlineIcon class="icon-size-md"/>
          instellen
        </dd-button>
      </div>
    </template>

    <div class="flex-col justify-content-between gap-xs">
      <div class="automation-card-content">
        <p v-if="runIntervalDescription === RunIntervalEnum.NEVER">
          {{ description }}
<!--          Automation staat niet aan.-->
        </p>
        <p v-else-if="runIntervalDescription === RunIntervalEnum.ONCE">
          Campagne <strong>eenmalig</strong> uitvoeren op <strong>{{ nextSendDate }}</strong>
        </p>
        <p v-else>
          Campagne <strong>{{ intervalDescription }}</strong> uitvoeren.
          De volgende uitvoering start op <strong>{{ nextSendDate }}</strong>
        </p>
      </div>
      <div class="flex-row align-items-center justify-content-end">
        <AutomationIconComponent
            v-bind:creates-signal="createsSignal"
            v-bind:creates-task="createsTask"
            v-bind:sends-email="sendsEmail"
            v-bind:is-campaign="isCampaign"
            v-bind:needs-verification="needsVerification"
        />
      </div>
    </div>
  </dd-header-card>
</template>

<script>
import { AutomationHelper } from '~/pages/automation/helpers'
import { AutomationTypeEnum, RunIntervalEnum } from '~/pages/automation/enums'
import AutomationIconComponent from '../AutomationIconComponent.vue'
import AutomationItemMixin from '~/mixins/automations/AutomationItem'

export default {
  name: 'UnconfiguredGlobalAutomation.vue',
  components: {
    AutomationIconComponent,
  },
  mixins: [AutomationItemMixin],
  props: {
    globalAutomation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      RunIntervalEnum,
    }
  },
  methods: {
    onConfigure () {
      this.navigator.navigatePath(this.route('vue.dashboard.automations.global.edit', {
        automation: this.globalAutomation.id,
      }))
    }
  },
  computed: {
    description () {
      return this.globalAutomation.description
    },
    sendsEmail () {
      return this.globalAutomation.send_email
    },
    createsSignal () {
      return this.globalAutomation.create_signal
    },
    createsTask () {
      return this.globalAutomation.create_task
    },
    isCampaign () {
      return this.globalAutomation.type === AutomationTypeEnum.CAMPAIGN
    },
    needsVerification () {
      return this.globalAutomation.needs_verification
    },
    isActive () {
      return AutomationHelper.isActive(this.globalAutomation)
    },
    runIntervalDescription () {
      if (this.runInterval === RunIntervalEnum.NEVER || this.runInterval === undefined || this.runInterval === null) {
        return RunIntervalEnum.NEVER
      } else if (this.automationConfiguration?.recurring === false) {
        return RunIntervalEnum.ONCE
      } else {
        return RunIntervalEnum.RECURRING
      }
    },
  },
}
</script>

